export default "/fonts/Gotham-Medium.woff?2b6ebb4888cef31ea7cf8436336abed9";